import type { Lounge } from '@/constants/area';

/**
 * ラウンジロゴ画像パス定数
 */
const LOUNGE_LOGO_PATHS = {
  SUITE_LOUNGE: '/Common_ANA_SUITELOUNGE.png',
  ANA_LOUNGE: '/Common_ANA_LOUNGE.png',
} as const;

/**
 * ラウンジタイプに応じたロゴ画像パスを取得
 */
const getLoungeLogo = (lounge: Lounge | string): string[] => {
  if (lounge === 'common') {
    return [LOUNGE_LOGO_PATHS.SUITE_LOUNGE, LOUNGE_LOGO_PATHS.ANA_LOUNGE];
  }
  if (lounge === 'suite_lounge') {
    return [LOUNGE_LOGO_PATHS.SUITE_LOUNGE];
  }
  // ana_lounge or default
  return [LOUNGE_LOGO_PATHS.ANA_LOUNGE];
};

interface LoungeLogoProps {
  /** ラウンジタイプ */
  lounge: Lounge | string;
  /** 画像に適用するCSSクラス */
  className?: string;
  /** 画像のalt属性 */
  altText?: string;
}

/**
 * ラウンジロゴ表示コンポーネント
 *
 * ラウンジタイプに応じて1つまたは2つのロゴ画像を表示します。
 * - common: SUITE LOUNGEとANA LOUNGEの2つを並べて表示
 * - suite_lounge: SUITE LOUNGEのみ表示
 * - ana_lounge: ANA LOUNGEのみ表示
 */
export const LoungeLogo = ({ lounge, className, altText }: LoungeLogoProps) => {
  const logos = getLoungeLogo(lounge);

  return logos.length > 1 ? (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        gap: '8px',
      }}
    >
      {logos.map((logo, index) => (
        <img key={index} className={className} src={logo} alt={altText} />
      ))}
    </div>
  ) : (
    <img className={className} src={logos[0]} alt={altText} />
  );
};
